import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HomeCrmService {
    private _crmUrl = new BehaviorSubject<string>(environment.crmUrl);

    get crmUrl$(): Observable<string> {
        return this._crmUrl.asObservable();
    }

    set crmUrl$(url: string) {
        this._crmUrl.next(url);
    }

    constructor() {}
}
